
import PIXI from '../GameEngine/pixi.js';
import Card from '../Sprites/Card.js'

export default class ScoreDetails extends PIXI.Container {
    constructor(title, starterCard, handCards, pointLogs, ...arg) {
        super(...arg);
        this.title = title;
        this.stageWidth = 550;
        this.stageHeight = 400;
        this.pointLogs = pointLogs;
        this.totalPoints = pointLogs.reduce(function (total, item) {
            return total + item.points;
        }, 0);

        this.interactive = true;
        this.on('pointerdown', this.close_onClick.bind(this));

        //popupBackground
        var popupBackground = new PIXI.Graphics();
        popupBackground.beginFill(0x000000);
        popupBackground.drawRect(-500, -500, 1000, 1000);
        popupBackground.alpha = 0.1;
        this.addChild(popupBackground);

        this.container = new PIXI.Container();
        this.addChild(this.container);


        // //background
        // var graphics = new PIXI.Graphics();
        // graphics.beginFill(0x333333);
        // graphics.lineStyle(0, 0xFFFFFF, 1);
        // // graphics.drawRect(0, 0, 500, 500);
        // graphics.drawRoundedRect(0, 0, 440, 400, 10);
        // // graphics.alpha = 0.5;
        // this.container.addChild(graphics);

        // this.color = color|| 0x479ACE;// or 0x479ACE or 0xC03500
        this.color = 0x479ACE;// or 0x479ACE or 0xC03500
        //titleBox
        var titleBox = new PIXI.Graphics();
        titleBox.beginFill(this.color);
        titleBox.drawRoundedRect(0, 0, 500, 80, 10);
        // titleBox.beginFill(0x333333);
        // titleBox.drawRoundedRect(0, 400, 550, 80, 10);
       this.container.addChild(titleBox);


        //background
        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x333333);
        graphics.drawRect(0, 50, 500, 350);
          this.container.addChild(graphics);







        //create title

        let styleTitle = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 30 * 2,
            fill: '#FFFFFF',
            align: 'center'
        });
        let styleLarge = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 50 * 2,
            fill: '#FFFFFF'
        });
        let styleNormal = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 20 * 2,
            fill: '#FFFFFF'
        });
        let styleSmall = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 12 * 2,
            fill: '#FFFFFF'
        });

        //textTitle
        this.textTitle = new PIXI.Text(this.title, styleTitle);
        this.textTitle.x = 220;
        this.textTitle.y = 7;
        this.textTitle.anchor.set(0.5, 0);
        this.textTitle.scale.set(0.5);
        this.container.addChild(this.textTitle);

        //textTapToContinue
        this.textTapToContinue = new PIXI.Text('Tap to continue', styleSmall);
        this.textTapToContinue.x = 250;
        this.textTapToContinue.y = 385;
        this.textTapToContinue.anchor.set(0.5, 0);
        this.textTapToContinue.scale.set(0.5);
        this.container.addChild(this.textTapToContinue);



        //point background
        var pointCircle = new PIXI.Graphics();
        pointCircle.beginFill(0xC03500);
        pointCircle.lineStyle(0, 0xFFFFFF, 1);
        pointCircle.drawRoundedRect(410, 5, 80,40,10);
        this.container.addChild(pointCircle);

        //textHandScore
        this.textHandScore = new PIXI.Text(this.totalPoints, styleTitle);
        this.textHandScore.x = 450;
        this.textHandScore.y = 7;
        this.textHandScore.anchor.set(0.5, 0);
        this.textHandScore.scale.set(0.5);
        this.container.addChild(this.textHandScore);


        // //point circle
        // var pointCircle = new PIXI.Graphics();
        // pointCircle.beginFill(0xC03500);
        // pointCircle.lineStyle(2, 0xFFFFFF, 1);
        // pointCircle.drawCircle(490, 100, 50);
        // this.container.addChild(pointCircle);

        // //textHandScore
        // this.textHandScore = new PIXI.Text('', styleLarge);
        // this.textHandScore.x = 490;
        // this.textHandScore.y = 100;
        // this.textHandScore.anchor.set(0.5, 0.5);
        // this.textHandScore.scale.set(0.5);
        // this.container.addChild(this.textHandScore);



        //create hand cards
        for (let i = 0; i < handCards.length; i++) {
            let card = handCards[i];
            let cardUI = new Card(card);
            cardUI.x = 50 + (i * 82);
            cardUI.y = 110;
            cardUI.width = 80;
            cardUI.height = 100;
            cardUI.showfront = false;
            cardUI.updateTexture();
            this.container.addChild(cardUI);
        }
        if (starterCard) {
            //starter card
            let card = starterCard;
            let cardUI = new Card(card);
            cardUI.x = 50 + (4 * 82) + 10;
            cardUI.y = 110;
            cardUI.width = 80;
            cardUI.height = 100;
            cardUI.showfront = false;
            cardUI.updateTexture();
            this.container.addChild(cardUI);
        }

    

        //create sets for each point log
        let maxRowPerColumn = 3;
        let colWidth = 180;
        let rowHeight = 75;
        let colOffset = 170;
        for (let i = 0; i < this.pointLogs.length; i++) {
            let pointLog = this.pointLogs[i];
            let cards = pointLog.cards;
            let column = Math.floor(i / maxRowPerColumn);
            let row = i % maxRowPerColumn;
            let x = column * colWidth;
            let y = colOffset + (row * rowHeight);
            //create hand cards
            for (let j = 0; j < cards.length; j++) {
                let card = cards[j];
                let cardUI = new Card(card);
                cardUI.x = x + 10 + (36 / 2) + (j * 38);
                cardUI.y = y + (50 / 2);
                cardUI.width = 36;
                cardUI.height = 50;
                cardUI.showfront = false;
                cardUI.updateTexture();
                this.container.addChild(cardUI);
            }
            //setScore text
            this.textSetScore = new PIXI.Text("+" + pointLog.points, styleNormal);
            this.textSetScore.x = x + 10;
            this.textSetScore.y = y + 50;
            this.textSetScore.scale.set(0.5);
            this.container.addChild(this.textSetScore);

            //setReason text
            this.textSetReason = new PIXI.Text(pointLog.reason, styleNormal);
            this.textSetReason.x = x + 50;
            this.textSetReason.y = y + 50;
            this.textSetReason.scale.set(0.5);
            this.container.addChild(this.textSetReason);
        }



        //center content
        this.container.x = 0 - (this.container.width / 2);
        this.container.y = 0 - (this.container.height / 2);


    }
    close_onClick(event) {
        this.parent.isDirty = true;
        this.parent.removeChild(this);
        event.stopPropagation();
    }


}